import { useState } from 'react';
import useStableCallback from 'src/hooks/useCallbackUtils/useStableCallback';
import useEffectWithCtx from 'src/hooks/useEffectUtils/useEffectWithCtx';
export default function useQuestionListSelection({ isMasterDetail, selectedQuestionID, onSelectedQuestionIDChange, items, }) {
    const [selectedQuestion, setSelectedQuestion] = useState(null);
    const [selectedIndex, setSelectedIndex] = useState(-1);
    const syncSelectionToRoute = !!onSelectedQuestionIDChange;
    useEffectWithCtx(ctx => {
        if (!ctx.isMasterDetail || !ctx.syncSelectionToRoute) {
            return;
        }
        if (!ctx.selectedQuestionID) {
            ctx.setSelectedQuestion(null);
            ctx.setSelectedIndex(-1);
            return;
        }
        const list = ctx.items;
        const index = list?.findIndex(q => q.id === ctx.selectedQuestionID) ?? -1;
        if (index >= 0 && list) {
            const fromList = list[index];
            if (ctx.selectedQuestion?.id !== fromList.id) {
                ctx.setSelectedQuestion(fromList);
                ctx.setSelectedIndex(index);
            }
            return;
        }
        if (ctx.selectedQuestion?.id !== ctx.selectedQuestionID) {
            ctx.setSelectedQuestion({ id: ctx.selectedQuestionID });
            ctx.setSelectedIndex(-1);
        }
    }, {
        isMasterDetail,
        syncSelectionToRoute,
        selectedQuestionID,
        selectedQuestion,
        items,
        setSelectedQuestion,
        setSelectedIndex,
    }, [isMasterDetail, onSelectedQuestionIDChange, selectedQuestionID, items]);
    const selectQuestion = useStableCallback((question, index) => {
        setSelectedQuestion(question);
        setSelectedIndex(index);
        onSelectedQuestionIDChange?.(question.id);
    });
    const clearSelection = useStableCallback(() => {
        setSelectedQuestion(null);
        setSelectedIndex(-1);
        onSelectedQuestionIDChange?.(undefined);
    });
    return {
        selectedQuestion,
        selectedIndex,
        selectQuestion,
        clearSelection,
    };
}
